module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-300italic.8debb2d5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-300italic.woff
// module id = 486
// module chunks = 0